import { render, staticRenderFns } from "./ParametersByLocation.vue?vue&type=template&id=66f19c74&scoped=true&"
import script from "./ParametersByLocation.vue?vue&type=script&lang=js&"
export * from "./ParametersByLocation.vue?vue&type=script&lang=js&"
import style0 from "./ParametersByLocation.vue?vue&type=style&index=0&id=66f19c74&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f19c74",
  null
  
)

export default component.exports